import SEOHead from '@/components/feature/SEOHead';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import FeaturedArticles from './components/FeaturedArticles';
import BrandStory from './components/BrandStory';

const homeJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '水蜜桃视频',
  url: 'https://teadaye.cn/',
  description: '专注于水蜜桃种植、采摘、品鉴与美食制作的短视频内容平台',
  potentialAction: {
    '@type': 'SearchAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate: 'https://teadaye.cn/search?q={search_term_string}',
    },
    'query-input': 'required name=search_term_string',
  },
};

const orgJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '水蜜桃视频',
  url: 'https://teadaye.cn/',
  description: '中国领先的水蜜桃主题短视频内容平台',
  foundingDate: '2020',
  contactPoint: {
    '@type': 'ContactPoint',
    telephone: '+86-571-8888-6666',
    contactType: 'customer service',
  },
  address: {
    '@type': 'PostalAddress',
    addressLocality: '杭州',
    addressRegion: '浙江',
    addressCountry: 'CN',
    streetAddress: '余杭区梦想小镇桃园路88号',
  },
};

export default function Home() {
  return (
    <>
      <SEOHead
        title="水蜜桃视频 - 甜蜜果香记录每一刻 | 水蜜桃种植采摘品鉴短视频平台"
        description="水蜜桃视频是专注于水蜜桃种植、采摘、品鉴与美食制作的短视频内容平台，带你深入果园现场，感受水蜜桃从花开到成熟的全过程，发现甜蜜生活的无限可能。"
        keywords="水蜜桃视频,水蜜桃种植视频,水蜜桃采摘记录,水蜜桃美食制作视频,水蜜桃果园直播,水蜜桃品鉴短视频"
        canonicalUrl="/"
      />
      <script type="application/ld+json">{JSON.stringify(homeJsonLd)}</script>
      <script type="application/ld+json">{JSON.stringify(orgJsonLd)}</script>
      <main>
        <HeroSection />
        <CategorySection />
        <FeaturedArticles />
        <BrandStory />
      </main>
    </>
  );
}